import React, { useCallback, useId } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { catalogSongMessages } from './catalogSongMessages';
import { withBrandWord } from '../../../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song files; each part uses its own slice of it */
import styles from './SongFiles.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface RightsConfirmRowProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * The rights checkbox of the first master upload of an account (design g1, D18). It shows only
 * while the account has not confirmed (`useMasterUpload().needsRights`).
 */
const RightsConfirmRowComponent: React.FC<RightsConfirmRowProps> = ({ checked, onChange, disabled = false }) => {
  const intl = useIntl();
  const inputId = useId();

  const change = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
    [onChange]
  );

  return (
    <label className={styles.rights} htmlFor={inputId}>
      <input id={inputId} type="checkbox" checked={checked} disabled={disabled} onChange={change} />
      <span>
        <b>{intl.formatMessage(catalogSongMessages.rights)}</b>
        <br />
        {withBrandWord(intl.formatMessage(catalogSongMessages.rightsNote))}
      </span>
    </label>
  );
};

export const RightsConfirmRow = TypedMemo(RightsConfirmRowComponent);
